import {connect} from "react-redux";
import { setDialogCustomizeShow } from "../../redux/actions/actions.js";
import Profile_Customize_ColorBtn from "../profile/Profile_Customize_ColorBtn";
import Profile_Customize_FontSize from "../profile/Profile_Customize_FontSize";
import Profile_Customize_BackgroundColor from "../profile/Profile_Customize_BackgroundColor";

const Dialog_Customize = (props) => {
    const {onSetDialogCustomizeShow,color_button,color_background,dialog_customize_show} = props;
    const closeDialog = () => {
        onSetDialogCustomizeShow("hide");
    }
    const closeOutside = (e) => {
        const isOutside = !e.target.closest('.dialog_customize');
        if (isOutside) {
            closeDialog();
        }
    }
    return(
        <div onClick={closeOutside} className={`dialog_window dialog_window_${color_background} dialog_window_${dialog_customize_show}`}>
            <div className={`dialog_customize dialog_${color_background}`}>
                <h1 className="profile_section_title">Customize your view</h1>
                <p className="profile_section_paragraph">Manage your font size, color, and background. These settings affect all the Twitter accounts on this browser.</p>
                <Profile_Customize_FontSize />
                <Profile_Customize_ColorBtn />
                <Profile_Customize_BackgroundColor />
                <div className="dialog_customize_button_div">
                    <button onClick={closeDialog} className={`dialog_customize_button customizecolorchange_hover customizecolorchange_${color_button}`}>Done</button>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        color_button: state.getColorButton.color_button,
        color_background: state.getColorBackground.color_background,
        user: state.getUser.user,
        dialog_customize_show: state.setDialogCustomizeShow.dialog_customize_show
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        onSetDialogCustomizeShow: (text) => dispatch(setDialogCustomizeShow(text))
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Dialog_Customize);